import DateOfBirthFields from './date-of-birth-fields';

export * from './date-of-birth-fields';
export default DateOfBirthFields;
